import axios from '@/helpers/axios'
import { useQuery } from '@tanstack/react-query'

export const useOryUpdateToken = (refreshTokenFromCookie: string | null) => {
  // console.log(
  //   '🚀 ~ useOryUpdateToken ~ useOryUpdateToken payload:',
  //   ` grant_type: 'refresh_token',
  //         client_id: ${import.meta.env.VITE_ORY_CLIENT_ID},
  //         refresh_token: ${refreshTokenFromCookie},
  //         scope: 'offline%20openid'`
  // )
  // console.log('🚀 ~ useOryUpdateToken ~  url:', `${import.meta.env.VITE_ORY_TOKEN}/oauth2/token`)
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['tokens'],
    queryFn: async () => {
      const response = await axios.post<any>(
        `${import.meta.env.VITE_ORY_TOKEN}/oauth2/token`,
        {
          grant_type: 'refresh_token',
          client_id: import.meta.env.VITE_ORY_CLIENT_ID,
          refresh_token: refreshTokenFromCookie,
          scope: 'offline%20openid'
        },
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          withCredentials: true
        }
      )
      return response.data
    },
    select: (data: any) => data,
    meta: { errorMessage: 'При получении токена произошла ошибка' },
    refetchInterval: 14 * 60 * 1000,
    staleTime: 14 * 60 * 1000,
    refetchIntervalInBackground: true,
    enabled: !!refreshTokenFromCookie && refreshTokenFromCookie !== '',
    retry: false
  })
  return {
    oryUpdateToken: data,
    oryUpdateTokenIsLoading: isLoading,
    oryUpdateTokenError: error,
    oryUpdateTokenRefetch: refetch
  }
}
